import { render, staticRenderFns } from "./Qr2.vue?vue&type=template&id=5125ff6e&scoped=true"
import script from "./Qr2.vue?vue&type=script&lang=js"
export * from "./Qr2.vue?vue&type=script&lang=js"
import style0 from "./Qr2.vue?vue&type=style&index=0&id=5125ff6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5125ff6e",
  null
  
)

export default component.exports